import { faDashboard, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import style from "./sidebar.module.css";
import routes from "../../../../assets/lang/routes";

const Sidebar = (isToggled) => {
  const location = useLocation();
  // const userId = useParams();
  // const id = Object.values(userId);

  return (
    <nav className={`${style.sidebar} `}>
      <div className={`${style.sidebarWrap} `}>
        <div className={`${style.sidebarItems}`}>
          <div className={`${style.sidebarItem} `}>
            <span className={`${style.sidebarItemLabel}`}></span>
            <Link
              className={` ${style.sidebarLink} ${
                location.pathname === "/admin/dashboard"
                  ? `${style.active}`
                  : ""
              } `}
              to="/admin/dashboard"
            >
              <div className={` ${style.sidebarLinkLogo} `}>
                <FontAwesomeIcon icon={faDashboard} />
              </div>
              {!isToggled.isToggled ? (
                <div className={`${style.sidebarLinkText}`}>Dashboard</div>
              ) : null}
            </Link>
          </div>

          <div className={` ${style.sidebarLine} `}></div>

          <div className={`${style.sidebarItem} `}>
            <span className={`${style.sidebarItemLabel}`}>User</span>
            <Link
              className={` ${style.sidebarLink} ${
                location.pathname === "/admin/users" ||
                location.pathname === "/admin/user/add"
                  ? `${style.active}`
                  : ""
              } `}
              to="/admin/users"
            >
              <div className={` ${style.sidebarLinkLogo} `}>
                <FontAwesomeIcon icon={faUser} />
              </div>
              {!isToggled.isToggled ? (
                <div className={`${style.sidebarLinkText}`}>User</div>
              ) : null}
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Sidebar;
